import { formatPhoneNumber } from '../formatPhoneNumber';

export type FormatCustomerNameArgs = {
  defaultCustomerName?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
};

export const formatCustomerName = ({
  defaultCustomerName = 'Customer',
  firstName = '',
  lastName = '',
  phoneNumber,
  email,
}: FormatCustomerNameArgs = {}): string => {
  if (firstName || lastName) {
    return `${firstName === null ? '' : firstName} ${
      lastName === null ? '' : lastName
    }`.trim();
  }

  if (phoneNumber) {
    return formatPhoneNumber(phoneNumber);
  }

  return email || defaultCustomerName;
};
